<template>
  <div
    class="street-mobile-combo"
    :class="{'priority-10': open}"
  >
    <!-- Input box -->
    <div
      class="input-box-holder width-10"
      :class="{ disabled }"
      v-validate="errors"
      v-has-value="value"
    >
      <div class="input-box">
        <input
          type="text"
          :value="value"
          :disabled="disabled"
          autocomplete="mobile-select-box-123132"
          @input="$emit('searching', $event.target.value)"
          @focus="open = true"
        >
        <slot></slot>
        <div v-if="!isTooltip" class="tooltip">
          <i class="icon icon--status-ok"></i>
        </div>
        <tooltip v-if="isTooltip">
          <slot name="tooltip"></slot>
        </tooltip>
      </div>
      <div class="validation-output">
        <slot name="validations"></slot>
      </div>
    </div>

    <!-- List with input -->
    <div
      class="wrapper fixed up background-white f-column priority-6 translate-right"
      :class="{'translate-0': open}"
    >
      <div class="width-10 f-center background-background gray-border-bottom">
        <div class="width-9 f-column f-center pt-1 pb-1">
          <!-- List header -->
          <div class="width-10 f-center mb-1">
            <i
              id="country-list-back"
              class="icon icon--arrow-left-mobile absolute" style="left: 0;"
              @click="open = false"
            ></i>
            <span class="font-gray font-medium">
              <slot></slot>
            </span>
          </div>

          <!-- Input box -->
          <div
            class="input-box-holder width-10"
            v-validate="errors"
            v-has-value="search"
          >
            <div class="input-box">
              <input
                type="text"
                ref="search"
                :value="search"
                autocomplete="mobile-select-box-12313112"
                @input="searching($event.target.value)"
              >
              <slot></slot>
            </div>
            <!-- Mobile validations -->
            <div class="validation-output"></div>
          </div>
        </div>
      </div>

      <div class="width-10 flex justify-content-center background-white full-height y-auto">
        <div class="width-9 f-center pb-2 full-height">
          <div class="width-10 pt-1 pb-2 full-height">
            <div class="mobile-list-holder f-column">
              <!-- Vybrata polozka -->
              <div v-if="value && value.length > 0" class="choosed-item">
                <span>{{value}}</span>
                <i @click="reset" class="icon icon--cross-white"></i>
              </div>

              <!-- Zoznam poloziek -->
              <ul class="mobile-list width-10 f-column" type="none">
                <li
                  v-for="(option, index) in filteredOptions"
                  :key="index"
                  @click="select(option)"
                >{{option.label}}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Tooltip } from "union_components";

export default {
  name: 'MobileSelectBox',
  components: {
    Tooltip,
  },
  props: {
    options: {
      required: false,
      type: Array,
      default: () => [],
    },
    value: {
      required: true,
    },
    errors: {
      required: false,
      type: Array,
      default: () => [],
    },
    allowFilter: {
      required: false,
      type: Boolean,
      default: () => true,
    },
		disabled: {
			required: false,
			type: Boolean,
			default: () => false,
		},
  },
  data() {
    return {
      open: false,
      search: '',
    };
  },
  computed: {
    /*
    * Ak property allowFilter sa rovna false computed nebude filtrovat
    * options a vrati cely array.
    * */
    filteredOptions() {
      if (!this.allowFilter) return this.options;
      return this.options.filter((option) => option.label.toLowerCase().indexOf(this.search.toLowerCase()) !== -1);
    },
    /*
    * Vrati true ak datum ma tooltip
    * */
    isTooltip() {
      return !!this.$slots.tooltip;
    },
  },
  methods: {
    /*
    * Zvoli hodnotu a zatvori komponent
    * */
    select(option) {
      this.$emit('input', option);
      this.open = false;
    },
    /*
    * Vymaze momentalnu hodnotu
    * */
    reset() {
      this.$emit('input', '');
    },
    /*
    * On searching
    * */
    searching(value) {
      this.search = value;
      this.$emit('searching', value);
    },
  },
  watch: {
    open(isOpen) {
      if (isOpen) {
        document.body.style.overflowY = 'hidden';
        document.body.style.height = '100vh';
        this.$refs.search.focus();
        this.search = '';
      } else {
        document.body.style.overflowY = 'visible';
        document.body.style.height = 'auto';
      }
    },
  },
};
</script>
